module.exports = __webpack_public_path__ + "static/functions-screen-1-4e9c02325653a7a0b60ac46d6cba8ad1.png";